import React from 'react';
import { StaticImport } from 'next/dist/shared/lib/get-img-props';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';

import ArrowIcon1 from '@public/images/newAboutUs/arrawIcon-1.svg';
import ArrowIcon2 from '@public/images/newAboutUs/arrawIcon-2.svg';
import ArrowIcon3 from '@public/images/newAboutUs/arrawIcon-3.svg';
import BrandIntroductionImg from '@public/images/newAboutUs/brand-introduction.png';
import Img1 from '@public/images/newAboutUs/brand-link-img-1.png';
import Img2 from '@public/images/newAboutUs/brand-link-img-2.png';
import Img3 from '@public/images/newAboutUs/brand-link-img-3.png';
import cls from 'classnames';

import MaxAndMediumScreen from '@/components/Device/MaxAndMediumScreen';
import Mobile from '@/components/Device/Mobile';
import Title from '@/components/Title';

import styles from './style.module.scss';

interface ILinkList {
  icon: string | StaticImport;
  arrow: string | StaticImport;
  key: string;
  link: string;
  text: string;
  bg: string;
}

const BrandIntroduction: React.FC = () => {
  const { t } = useTranslation('aboutus');
  const linkList: ILinkList[] = [
    {
      icon: Img1,
      key: 'Chinese',
      link: '/chinese/',
      text: t('品牌介绍-国际中文'),
      bg: styles.bg1,
      arrow: ArrowIcon1,
    },
    {
      icon: Img2,
      key: 'Math',
      link: '/math/',
      text: t('品牌介绍-国际数学'),
      bg: styles.bg2,
      arrow: ArrowIcon2,
    },
    {
      icon: Img3,
      key: 'English(ELA)',
      link: '/english/',
      text: t('品牌介绍-英文阅读写作'),
      bg: styles.bg3,
      arrow: ArrowIcon3,
    },
  ];
  return (
    <div className="lg:mt-30 mx-5 mt-20 flex max-w-[984px] flex-col lg:mx-auto lg:flex-row xl:mt-[176px] xl:max-w-[1400px]">
      <Mobile>
        <Title
          className=" relative z-20 mx-5 text-left text-[28px] [&]:lg:leading-normal [&]:xl:leading-normal"
          innerHTML
          theme="colorful"
          htmlLabel="h1"
        >
          {t('品牌介绍-title')}
        </Title>
      </Mobile>
      <Image
        src={BrandIntroductionImg}
        alt=""
        width={400}
        height={400}
        className="mb-[10px] h-[335px] w-[335px] lg:mb-0 lg:mr-[40px] lg:h-[400px] lg:w-[400px] xl:mr-[60px] xl:h-[488px] xl:w-[488px]"
      />
      <div className="flex flex-col">
        <MaxAndMediumScreen>
          <Title
            className="relative z-20 mx-5 mb-4 w-full  text-wk-words-1 lg:text-left xl:mb-6 [&]:lg:text-[34px] [&]:lg:leading-normal [&]:xl:text-[48px] [&]:xl:leading-normal"
            innerHTML
            theme="colorful"
            htmlLabel="h1"
          >
            {t('品牌介绍-title')}
          </Title>
        </MaxAndMediumScreen>
        <div
          className="space-y-4 text-[14px] text-wk-words-2 xl:space-y-6 xl:text-[20px] xl:leading-[28px]"
          dangerouslySetInnerHTML={{ __html: t('品牌介绍-content') }}
        />
        <div className="mt-5 grid grid-cols-3 gap-4 lg:mt-4 xl:mt-6">
          {linkList.map(({ link, key, icon, text, bg, arrow }) => {
            return (
              <Link
                className={cls(
                  bg,
                  styles.card,
                  'hiddlen relative h-[124px] w-[100px] rounded-2xl border-2 border-white p-2 shadow-[0px_12px_30px_0px_rgba(0,0,0,0.04)] lg:h-[102px] lg:w-[170px] lg:p-3 lg:shadow-none xl:h-[130px] xl:w-[280px] xl:p-5 xl:pb-3',
                )}
                key={key}
                href={link}
                target="_blank"
              >
                <Image
                  src={icon}
                  alt=""
                  width={200}
                  height={150}
                  className="absolute bottom-0 right-0 h-[75px] w-[100px] xl:h-[106px] xl:w-[140px]"
                />
                <Image
                  src={arrow}
                  alt=""
                  width={20}
                  height={20}
                  className="absolute bottom-[56px]  left-2 h-5 w-5 lg:bottom-3 lg:left-3 lg:h-7 lg:w-7 xl:bottom-5 xl:left-5 xl:h-8 xl:w-8"
                />
                <div
                  className="relative text-[14px] font-bold leading-normal lg:text-[16px] xl:text-[20px]"
                  dangerouslySetInnerHTML={{ __html: text }}
                />
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BrandIntroduction;
